import React from 'react';
import { useSelector } from 'react-redux';

import PropertyCard from '../../AdvertsList/components/PropertyCard';

const SaleCardMap = () => {
  // ------------------------------- CONSTRUCTOR -------------------------------
  const { property } = useSelector((state) => state.properties);
  // -------------------------------- MAIN VIEW --------------------------------
  return (
    <div className='vesta-sale-card-map' onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} >
      {property && <PropertyCard key={property.id} property={property} />}
    </div>
  );
};

export default SaleCardMap;
